import 'assets/scss/index.scss'
import 'swiper/css'
import 'swiper/css/virtual'

import type { AppProps } from 'next/app'

import DefaultLayout from '@ui/layouts/default'
import MyHead from '@ui/components/next/MyHead'
import Error from './_error'
import { OrderProvider } from '@ui/contexts'
import type { NEXT_DATA } from 'next/dist/shared/lib/utils'

import { initSentry } from '@ui/analytics'
import { usePostHogTracking } from '@ui/hooks/usePostHogTracking'
import { useSentryUser } from '@ui/hooks/useSentryUser'
import { initializeClientState } from '@ui/helpers/initializeState'
import { useInitState } from '@libs/client/order/hooks/useInitState'

declare global {
  interface Window {
    __NEXT_DATA__: NEXT_DATA
    initMap?: () => void
    google?: any
  }
}

if (typeof window !== 'undefined') {
  initializeClientState()
}

initSentry()

function MyApp({ Component, pageProps }: AppProps) {
  usePostHogTracking()
  useSentryUser()

  useInitState({
    storeConfiguration: {
      shopName: pageProps?.storeName || 'ShopHelp',
      shopTitle: pageProps?.shopTitle || 'ShopHelp',
      showCompany: !!pageProps?.showCompany || false,
      showPhone: !!pageProps?.showPhone || false,
      showAddress: !!pageProps?.showAddress || false,
      logo: {
        width: pageProps?.logoWidth || 200
      }
    }
  })

  if (pageProps?.statusCode >= 400) return <Error statusCode={pageProps.statusCode} />

  return (
    <>
      <MyHead />
      <DefaultLayout>
        <OrderProvider>
          <Component {...pageProps} />
        </OrderProvider>
      </DefaultLayout>
    </>
  )
}

export default MyApp
